import { render } from "./InterfaceDialogContainer.vue?vue&type=template&id=773de11d&scoped=true"
import script from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"

import "./InterfaceDialogContainer.vue?vue&type=style&index=0&id=773de11d&scoped=true&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773de11d"]])

export default __exports__